import React from "react";
import { component_tool } from "@/tool";
const {
  WizIcon,
  WizTooltip,
} = component_tool;

const hiddenTypeEnum = {
  content: 0,
  learningMaterials: 1
}, hiddenTypeToCategoryEnum = {
  content: 5,
  learningMaterials: 17,
}, categoryStrEnum = {
  content: '内容分类',
  learningMaterials: '分类'
}, defaultReleasePlatformEnum =  {
  content: ['1', '2'],
  learningMaterials: ['1', '2', '3'],
}, switchShareTipEnum = {
  content: '(只针对于APP)',
  learningMaterials: '(只针对于APP)'
}, defaultSwitchShareEnum = {
  content: 1,
  learningMaterials: 0,
}, defaultSwitchCommentEnum = {
  content: 1,
  learningMaterials: 0,
}


const baseFields = (initialValue = {}, hiddenType) => {
  return [
    {
      name: "id",
      initialValue: initialValue.id,
      type: 'hidden'
    },
    {
      name: "contentType",
      initialValue: initialValue.contentType || 1,
      type: 'hidden'
    },
    {
      name: "hiddenType",
      initialValue: hiddenTypeEnum[hiddenType],
      type: 'hidden'
    },
    {
      name: "categoryIds",
      label: categoryStrEnum[hiddenType],
      type: "categoryIds",
      initialValue: initialValue.categoryArr || [],
      compProps: {
        returnKey: true,
        wizTreeSelectListProps: {
          checkable: false,
          itemProps: {
            icon: 'unordered-list',
            title: categoryStrEnum[hiddenType],
            tips: '请勾选所属' + categoryStrEnum[hiddenType]
          },
          treeProps: { checkStrictly: true }
        },
        apiProps: { type: hiddenTypeToCategoryEnum[hiddenType] },
        selectProps: {
          placeholder: '请选择' + categoryStrEnum[hiddenType]
        },
        initSelects: initialValue.categoryArr || [],
        rules: [{
          type: 'array'
        }]
      },
      required: true,
    },
    {
      name: "title",
      label: "标题",
      type: "input",
      initialValue: initialValue.title,
      required: true,
    },
    {
      name: "remark",
      label: "摘要",
      type: "textArea",
      initialValue: initialValue.remark,
    },
    {
      name: "author",
      label: "作者",
      type: "input",
      initialValue: initialValue.author,
      required: true,
    },
    {
      name: "releaseTime",
      label: "发布时间",
      type: "date",
      initialValue: initialValue.releaseTime,
      required: true,
    },
    {
      name: "fileId",
      label: <span>
      封面&nbsp;
      <WizTooltip title="请上传大小不超过1MB,图片尺寸建议1600*800">
          <WizIcon type="question-circle-o" />
      </WizTooltip>
    </span>,
      type: "upload",
      initialValue: initialValue.fileImgObj,
      required: true,
    },
    hiddenType === 'content' ? {
      name: "labelIds",
      label: "标签",
      type: "selectMul",
      initialValue: initialValue.labelIds && initialValue.labelIds.map(val => val.id),
      compProps: {
        selectType: 'checkbox',
        initRows: initialValue.labelIds && initialValue.labelIds.length ? initialValue.labelIds.map(val => { return { id: val.id, title: val.name } }) : [],
        placeholder: '请选择标签'
      }
    } : null,
    {
      name: "authCmd",
      label: "内容受众",
      type: "authCmd",
      //initialValue: initialValue.targetScoreInfo,
      initialValue: Object.assign({}, initialValue.targetScoreInfo),
      compProps: {
        mode: 'Form',
        record: {
          authCmd: initialValue.targetScoreInfo
        },
        keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds'],
      },
      required: true,
     // labelCol: { span: 6 },
      wrapperCol: { span: 14},
    },
  ].filter(item => !!item)
}
const editFields = (initialValue = {}, hiddenType) => {
  return [
    {
      name: "releasePlatform",
      label: "发布平台",
      type: "checkbox",
      initialValue: initialValue.releasePlatform === undefined ? defaultReleasePlatformEnum[hiddenType] : initialValue.releasePlatform.split(','),
      fields: [
        { label: "PC", value: '1' },
        { label: "APP", value: '2' },
        // { label: "小程序", value: '4' },
      ].filter(item => !!item),
    },
    {
      name: "switchLike",
      label: "点赞功能",
      type: "radio",
      initialValue: initialValue.switchLike === undefined ? 1 : initialValue.switchLike,
      fields: [
        { label: "打开", value: 1 },
        { label: "关闭", value: 0 },
      ],
    },
    hiddenType === 'learningMaterials' ? null :{
      name: "releaseState",
      label: "发布状态",
      initialValue: initialValue.releaseState === undefined ? 0 : initialValue.releaseState,
      type: "radio",
      fields: [
        { label: "草稿", value: 0 },
        { label: "已发布", value: 1 },
        { label: "取消发布", value: 2 },
      ],
    },
    {
      name: "switchShare",
      label: "分享功能",
      type: "radio",
      initialValue: initialValue.switchShare === undefined ? defaultSwitchShareEnum[hiddenType] : initialValue.switchShare,
      fields: [
        { label: "打开", value: 1 },
        { label: "关闭", value: 0 },
      ],
      tip: switchShareTipEnum[hiddenType],
    },
    {
      name: "switchTop",
      label: "是否置顶",
      type: "radio",
      initialValue: initialValue.switchTop === undefined ? 0 : initialValue.switchTop,
      fields: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ],
    },
    {
      name: "switchComment",
      label: "评论功能",
      type: "radio",
      initialValue: initialValue.switchComment === undefined ? defaultSwitchCommentEnum[hiddenType] : initialValue.switchComment,
      fields: [
        { label: "打开", value: 1 },
        { label: "关闭", value: 0 },
      ],
    },
  ].filter(item => !!item)
}

const contentFields = (initialValue = {}, hiddenType) => {
  return [
    // {
    //   name: "contentType",
    //   label: "请选择内容类型",
    //   type: "select",
    //   initialValue: initialValue.contentType || 1,
    //   fields: [
    //     { label: "文章", value: 1 },
    //     { label: "图片", value: 2 },
    //     { label: "视频", value: 3 },
    //     // { label: "文档文件", value: 4 },
    //     { label: "下载文件", value: 5 },
    //   ],
    //   labelCol: {
    //     span: 5,
    //   },
    //   wrapperCol: {
    //     span: 6,
    //   },
    // },
    {
      name: "contentTextList",
      type: "diy",
      wrapperCol: {
        span: 24,
      },
      compProps: {
        hiddenType: hiddenType,
        contentType: initialValue.contentType,
        watermark: initialValue.watermark
      },
      initialValue: initialValue.contentTextList || []
    },
  ]
}

export {baseFields, editFields, contentFields}
